import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsOnboardingHubCreateRoute: InvariantJiraRoute = {
	name: 'products-onboarding-hub-create',
	path: '/jira/settings/products/onboarding/new',
};
